import { Link } from 'react-router-dom';
export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-bg text-text-primary">
      <h1 className="text-3xl font-bold text-primary">404 — Not found</h1>
      <Link to="/" className="mt-4 text-primary hover:underline">Home</Link>
    </div>
  );
}
